import { Component } from '@angular/core';

@Component({
  selector: 'phoenix-no-data',
  template: `
    <div id="no-data" class="flex">
      <p class="theme-text-2">No data available&nbsp;</p>
      <mat-icon class="theme-text-2">sentiment_dissatisfied</mat-icon>
    </div>
  `,
  standalone: false,
})
export class NoDataComponent {}
